import { ENTITY_TYPE } from '@/constants/entities'
import { explorePageTabsIds } from '@/constants/explore'
import { ROUTE_NAMES } from '@/constants/routes'
import { STORAGE_KEYS } from '@/constants/storage'
import localStorage from '@/utils/localStorage'
import safeJSONParse from '@/utils/safeJSONParse'
import { mapGetters } from 'vuex'

/**
 * This is the mixin for User Lists. It provides utils for List CRUD
 * This expects subOrgId to be present as a property wherever getting used.
 */
export default {
  computed: {
    ...mapGetters('userLists', ['userLists', 'listById']),
    userSavedLists() {
      return this.userLists(this.subOrgId)
    },
    selectedListId() {
      return this.getActiveListId(this.$route.query)
    },
    selectedList() {
      return this.listById(this.selectedListId)
    },
    selectedListName() {
      return this.selectedList?.name
    }
  },
  methods: {
    getListEntityTabId(list) {
      if (list.entityType === ENTITY_TYPE.GOAL) {
        return explorePageTabsIds.goals
      } else if (list.entityType === ENTITY_TYPE.KEY_RESULT) {
        return explorePageTabsIds.keyResults
      } else {
        return explorePageTabsIds.initiatives
      }
    },
    getListLocation(list) {
      return {
        name: ROUTE_NAMES.EXPLORE_ALL,
        params: {
          orgId: this.orgId,
          subOrgId: this.subOrgId,
          entity: this.getListEntityTabId(list)
        },
        query: { ...list.filterData, listId: list.id }
      }
    },
    getUserAllInitiativeLists(userId) {
      const lists = safeJSONParse(localStorage.getItem(STORAGE_KEYS.initiativeLists)) || {}
      const userLists = []
      Object.keys(lists).forEach(teamId => {
        lists[teamId][userId]?.forEach(list => {
          list.teamId = teamId
          userLists.push(list)
        })
      })
      return userLists
    },
    setListMigrationUpdateFlag(userId) {
      localStorage.setItem(`${STORAGE_KEYS.initiativeListsMigrationFlag}-${userId}`, true)
    },
    getListMigrationUpdateFlag(userId) {
      return localStorage.getItem(`${STORAGE_KEYS.initiativeListsMigrationFlag}-${userId}`)
    },
    getActiveListId(query) {
      const listId = query.listId
      return +listId
    }
  }
}
